<template>
  <div class="inspector-legend-selection">
    <span v-for="legend in InspectorBus.skuLegends"
          :key="legend.id"
          class="sku-legend"
          :class="legend.id"
          @click="handleClickLegends(legend)">
      <span v-if="legend.id === 'unrecognized'">?</span>
      {{ isMobile && legend.mobileName ? legend.mobileName : legend.name }}
      <i v-if="legend.isChecked"
         :style="`color:${legend.color}`"
         class="el-icon-check" />
    </span>
  </div>
</template>

<script>
import InspectorBus from '../InspectorBus';
import bus from '../report-inspector-scene/bus';

export default {
  name: 'LegendsBar',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      InspectorBus
    };
  },
  methods: {
    handleClickLegends(legend) {
      // eslint-disable-next-line
      legend.isChecked = !legend.isChecked;

      this.$emit('legendClicked', { legend, isChecked: legend.isChecked });

      if (legend.id === 'unrecognized') {
        bus.show_unrecognized_sku = !bus.show_unrecognized_sku;
        bus.toggleSkuByType();

        // change unrecognized class
        const findUnrecognizeClassIndex = InspectorBus.selectClass.findIndex(item => item.id === 'unrecognized');
        InspectorBus.selectClass[findUnrecognizeClassIndex].isChecked = !InspectorBus.selectClass[findUnrecognizeClassIndex].isChecked;
      }
    }
  }
};
</script>

<style lang="scss">
.inspector-legend-selection {
  display: flex;

  .sku-legend {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    padding: 5px 10px;
    margin-right: 3px;
    font-size: 12px;
    font-weight: bold;
    white-space: nowrap;
    cursor: pointer;
    border-radius: 2px;

    i {
      margin-left: 10.13px;
    }

    @include breakpoint(lg-max) {
      padding: 2px 5px;
      margin-right: 2px;
      font-size: 8px;

      i {
        margin-left: 5px;
      }
    }

    &.out_of_stock {
      color: #f44;
      border: 1.5px solid #f44;
    }

    &.missing {
      color: #f9cb49;
      border: 1.5px solid #f9cb49;
    }

    &.misplaced {
      color: #6efff1;
      border: 1.5px solid #6efff1;
    }

    &.excess {
      color: #76ff5f;
      border: 1.5px solid #76ff5f;
    }

    &.unrecognized {
      color: #777;
      border: 1.5px solid #777;
    }
  }
}
</style>
